import { DeleteForeverOutlined } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import * as React from "react";
import styled from "styled-components";

interface Props {
    keyId: string;
    onDeleteClick: () => void;
}

const Wrapper = styled.div`
    background-color: white;
    border-radius: 8px;
    padding: 10px;
    display: flex;
    flex-direction: row;
    gap: 10px;
    font-size: 13px;
    width: 300px;
    justify-content: space-between;
`;

export default function TokenSecurityKey({ keyId, onDeleteClick }: Props): JSX.Element {
    return (
        <Wrapper>
            <div>
                <div>
                    <strong>KeyID: </strong>
                </div>
                <div>{keyId}</div>
            </div>
            <div>
                <IconButton onClick={onDeleteClick} color="error">
                    <DeleteForeverOutlined />
                </IconButton>
            </div>
        </Wrapper>
    );
}
